import './index.scss';

import React from 'react';

import CountButton from '../count-button';
import ImageTag from '../image-tag';

import NonVegLabel from '../../../assets/images/non-veg.png';
import VegLabel from '../../../assets/images/veg.svg';
import { LocalSessionKey } from '../../burger-king-lib/constants/app-constants';
import { SessionStorage } from '../../burger-king-lib/utils/storage';
import { getCategoryImage } from '../../utils/services';
import LocationRestriction from '../location-restriction-popover';

class GeneralCard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      noService: false
    };
  }

  onRestrict = () => {
    this.setState({ noService: true });
  };

  closeAlertModal = () => {
    this.setState({ noService: false });
  };

  render() {
    const {
      item,
      isHorizontal,
      isFromSearch,
      theme,
      ImgOnclick,
      addOnClick,
      isblockType,
      categoryPayload,
      title,
      pathName
    } = this.props;
    const {
      cart_quantity,
      name,
      food_type,
      description,
      variant_category,
      variant,
      isMustTry,
      is_combo,
      is_addon,
      image_urls
    } = item;
    const { noService } = this.state;
    const outletId = SessionStorage.get(LocalSessionKey.OUTLET_ID);
    const outletStatus = SessionStorage.get('Store_Status') || {};
    const imageUrl =
      isHorizontal && pathName !== '/m-product-listing'
        ? getCategoryImage(image_urls, 'plp')
        : getCategoryImage(image_urls, 'hpiv');
    // price == discount price == amount
    const amount =
      (variant_category &&
        variant_category[0] &&
        variant_category[0].variants &&
        variant_category[0].variants[0] &&
        variant_category[0].variants[0].actual_price) ||
      item.variant?.actual_price;
    const offerPrice =
      (variant_category &&
        variant_category[0] &&
        variant_category[0].variants &&
        variant_category[0].variants[0] &&
        variant_category[0].variants[0].price) ||
      item.variant?.price;
    const deliveryPrice =
      variant_category &&
      variant_category[0] &&
      variant_category[0].variants &&
      variant_category[0].variants[0] &&
      variant_category[0].variants[0].delivery_price;

    const renderNutritionInfo = item => {
      if (item?.isFirstItem) {
        return (
          <div
            style={{
              color: '#616161',
              fontSize: '14px'
            }}
          >
            {item?.nutritionValue} {item?.nutritionUnit}
          </div>
        );
      }
    };

    return (
      <div
        className={`card-gen_wrapper ${
          isblockType ? 'card-gen_wrapper__block' : ''
        }`}
      >
        <div
          className={`card-gen ${isHorizontal ? 'card-gen_horizontal' : ''} ${
            isFromSearch ? ' card-gen_search' : ''
          }`}
        >
          <div
            className="card-gen__image"
            onClick={
              outletId === 32236 || (outletStatus && outletStatus.status)
                ? this.onRestrict
                : null
            }
            role="presentation"
          >
            <picture>
              <source
                srcSet={`${imageUrl['1x']}, ${imageUrl['2x']} 2x, ${imageUrl['3x']} 3x`}
                type="image/jpeg/png"
              />
              <img
                src={`${imageUrl['2x']}`}
                alt={name}
                className="card-gen__img"
              />
            </picture>

            {isMustTry ? (
              <div className="card-gen__tag">
                <ImageTag />{' '}
              </div>
            ) : (
              ''
            )}
          </div>
          <div className="card-gen__content">
            <div className="card-gen__top">
              <div className="card-gen__item">
                <div
                  className="card-gen__name u_cursor_pointer"
                  onClick={
                    outletId === 32236 || (outletStatus && outletStatus.status)
                      ? this.onRestrict
                      : null
                  }
                  role="presentation"
                >
                  <div className="card-gen__name-text">{name}</div>
                  <div className="card-gen__description">{description} </div>
                  <div className="card-gen__descriptionNutrition">
                    {variant_category?.[0]?.variants?.[0]?.nutritional_data ? (
                      <div className="nutrition-info">
                        {variant_category[0].variants[0].nutritional_data.map(
                          (item, index) => (
                            <div key={index}>{renderNutritionInfo(item)}</div>
                          )
                        )}
                      </div>
                    ) : (
                      variant?.nutritional_data && (
                        <div className="nutrition-info">
                          {variant.nutritional_data.map((item, index) => (
                            <div key={index}>{renderNutritionInfo(item)}</div>
                          ))}
                        </div>
                      )
                    )}
                  </div>
                </div>
                <div className="card-gen__label">
                  <img
                    src={food_type === 'veg' ? VegLabel : NonVegLabel}
                    alt=""
                    width={food_type !== 'veg' && '12'}
                  />
                </div>
              </div>
            </div>
            <div className="card-gen__bottom">
              <div className="card-gen__price">
                {deliveryPrice && deliveryPrice > amount ? (
                  <div>
                    <span className="card-gen__discountamount">
                      ₹{deliveryPrice}/-
                    </span>
                  </div>
                ) : (
                  ''
                )}
                <div className="card-gen__amount">
                  {offerPrice === null ? (
                    <span className="card-gen__currency">
                      ₹ {Math.round(amount)}/-
                    </span>
                  ) : (
                    <>
                      <span className="card-gen__currency">
                        ₹ {offerPrice ? Math.round(offerPrice) : 0}/-
                      </span>
                      {amount && amount > 0 && (
                        <span className="card-gen__offer-currency">
                          ₹ {Math.round(amount)}/-
                        </span>
                      )}
                    </>
                  )}
                </div>
              </div>
              <div className="card-gen__addtocart">
                <CountButton
                  theme={theme}
                  countClick={
                    Math.round(amount) === 0
                      ? () => {}
                      : isAdd => addOnClick(isAdd, item, categoryPayload, title)
                  }
                  content={cart_quantity}
                />
              </div>
              {noService && (
                <LocationRestriction
                  title={
                    outletStatus && outletStatus.title
                      ? outletStatus.title
                      : 'Sorry!'
                  }
                  description={
                    outletStatus && outletStatus.status
                      ? outletStatus.status
                      : 'None of our restaurants are near you. Please try with some other location.'
                  }
                  okayClick={this.closeAlertModal}
                  theme={theme}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default GeneralCard;
